export default {
  info: state => state.info,
  albums: state => state.albums,
  singles: state => state.singles
};
